module.exports = __webpack_public_path__ + "static/media/gallery07.19a7f84c.jpg";